import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketLinkComponent } from './ticket-link.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { ProgressButtonModule } from '@fleet/shared';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { TitleCaseAndCleanPipeModule } from '@fleet/pipes';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { FuseAlertModule } from '@fleet/fuse';
import { AlertsFromIssuesModule } from '@fleet/issue';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TicketHubspotControlModule } from '../ticket-hubspot-control/ticket-hubspot-control.module';
import { DialogLayoutModule } from '@fleet/ui';

@NgModule({
  declarations: [TicketLinkComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatIconModule,
    ProgressButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    TitleCaseAndCleanPipeModule,
    MatButtonModule,
    MatDialogModule,
    FuseAlertModule,
    AlertsFromIssuesModule,
    MatCheckboxModule,
    MatDatepickerModule,
    TicketHubspotControlModule,
    DialogLayoutModule,
  ],
  exports: [TicketLinkComponent],
})
export class TicketLinkModule {}
